export const environment = {
  production: false,
  // baseUrl: 'http://localhost:8080/api',
  baseUrl: 'https://vinglobalbd.com/backend/api',
};
